import { whatIfInnerSelector, whatIfOptionsOrDefaultSelector } from '../../WhatIfsSelector';
import { selectCurrentClient } from '../../../CommonSelectors/CommonAreaSelector';
import { Donor } from '../../../CharitableGivingWorkflow/stages/CharitableGiving/api/useCharitableGivingQuery';

export const donationStartYearSelector = (state, props) =>
  whatIfInnerSelector(state, props).DonationStartYear;

export const donationEndYearSelector = (state, props) =>
  whatIfInnerSelector(state, props).DonationEndYear;

export const isRecurringSelector = (state, props) => whatIfInnerSelector(state, props).IsRecurring;

export const dafDonationStartYearSelector = (state, props) =>
  whatIfInnerSelector(state, props).DafDonationStartYear;

export const dafDonationEndYearSelector = (state, props) =>
  whatIfInnerSelector(state, props).DafDonationEndYear;

export const dafGrantStartYearSelector = (state, props) =>
  whatIfInnerSelector(state, props).DafGrantStartYear;

export const dafGrantEndYearSelector = (state, props) =>
  whatIfInnerSelector(state, props).DafGrantEndYear;

const getAgeRightLabel = (state, value, donor = null) => {
  const { Dob: primaryDob, PartnerDob: spouseDob } = selectCurrentClient(state);
  const hasDonor = donor !== null;

  const primaryYob = primaryDob ? new Date(primaryDob).getFullYear() : null;
  const spouseYob = spouseDob ? new Date(spouseDob).getFullYear() : null;
  if (!primaryYob || !value) return null;

  return primaryYob && hasDonor
    ? donor === Donor.Principal
      ? `Age ${value - primaryYob}`
      : spouseYob
      ? `Age ${value - spouseYob}`
      : ''
    : primaryYob
    ? `Age ${value - primaryYob}${spouseYob ? `, Age ${value - spouseYob}` : ''}`
    : undefined;
};

export const yearsOptionsSelector = (state, props) => {
  const whatIfOptions = whatIfOptionsOrDefaultSelector(state, props);
  const donor = whatIfOptions.donor ?? null;
  return (whatIfOptions.yearsOptions || []).map(y => ({
    value: y,
    label: y.toString(),
    rightLabel: getAgeRightLabel(state, y, donor),
  }));
};

export const dafStartYearOptionsSelector = (state, props) => {
  const whatIfOptions = whatIfOptionsOrDefaultSelector(state, props);

  return (whatIfOptions.dafStartYearOptions || []).map(option => ({
    ...option,
    rightLabel: getAgeRightLabel(state, option.value),
  }));
};

export const dafEndYearOptionsSelector = (state, props) => {
  const whatIfOptions = whatIfOptionsOrDefaultSelector(state, props);

  return (whatIfOptions.dafEndYearOptions || []).map(option => ({
    ...option,
    rightLabel: getAgeRightLabel(state, option.value),
  }));
};
